import * as Yup from 'yup';
import { BaseForm } from '../../../../shared/domain/forms/BaseForm';
import { EOccurrenceStatus } from '../../../../shared/enums/ocurrenceStatus';
import {
  isDateTimeInFuture,
  isValidDateTimeInput
} from '../../../../utils/date';

export class CreateEditOccurrenceDetailsForm extends BaseForm<CreateEditOccurrenceDetailsForm> {
  id: string = '';
  documentNumber: string = '';
  status: EOccurrenceStatus = EOccurrenceStatus.Waiting;
  userId: string = '';
  adminId: string = '';
  address: string = '';
  latitude: string = '';
  longitude: string = '';
  country: string = '';
  stateId: string = '';
  regionId: string = '';
  cityId: string = '';
  neighborhoodId: string = '';
  subNeighborhoodId: string = '';
  localityId: string = '';
  date: string = '';
  sourceId: string = '';
  complementarySourceId: string = '';
  policeAction: boolean | undefined = undefined;
  agentPresence: boolean | undefined = undefined;
  description: string = '';
  relatedRecord: string = '';

  validationSchema = Yup.object().shape({
    address: Yup.string()
      .nullable()
      .required(this.requiredDefaultMsg('endereço')),
    latitude: Yup.string()
      .nullable()
      .required(this.requiredDefaultMsg('latitude')),
    longitude: Yup.string()
      .nullable()
      .required(this.requiredDefaultMsg('longitude')),
    stateId: Yup.string()
      .nullable()
      .required(this.requiredDefaultMsg('estado')),
    cityId: Yup.string().nullable().required(this.requiredDefaultMsg('cidade')),
    neighborhoodId: Yup.string()
      .nullable()
      .required(this.requiredDefaultMsg('bairro')),
    date: Yup.string()
      .nullable()
      .required(this.requiredDefaultMsg('data'))
      .test('valid-date-time', 'Data da ocorrência inválida', value => {
        if (!value) return true;
        return isValidDateTimeInput(value);
      })
      .test(
        'not-in-future',
        'A data da ocorrência não pode ser no futuro',
        value => {
          if (!value) return true;
          return !isDateTimeInFuture(value);
        }
      ),
    sourceId: Yup.string()
      .nullable()
      .required(this.requiredDefaultMsg('fonte')),
    complementarySourceId: Yup.string().nullable(),
    policeAction: Yup.boolean().required(
      this.requiredDefaultMsg('ação policial')
    ),
    agentPresence: Yup.boolean().required(
      this.requiredDefaultMsg('presença de agentes')
    ),
    description: Yup.string()
      .nullable()
      .required(this.requiredDefaultMsg('descrição'))
  });

  constructor(data?: Partial<CreateEditOccurrenceDetailsForm>) {
    super();
    Object.assign(this, data);
  }
}
